import { useTranslation } from "react-i18next";
import { Sparkles, BookMarked } from "lucide-react";
import type { FieldSource } from "@arna-med/shared";

/**
 * Says who wrote a line of the report.
 *
 * Only shown for text the system supplied. What the doctor said and what they
 * typed carries no badge — that is the normal case and labelling it would bury
 * the two cases that matter under noise.
 */
export function SourceBadge({ source }: { source: FieldSource | undefined }) {
  const { t } = useTranslation();
  if (source !== "default" && source !== "protocol") return null;

  const isDefault = source === "default";
  const Icon = isDefault ? Sparkles : BookMarked;

  return (
    <span
      className={`ml-2 inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-normal align-middle ${
        isDefault
          ? "border-sky-200 bg-sky-50 text-sky-700"
          : "border-violet-200 bg-violet-50 text-violet-700"
      }`}
    >
      <Icon className="h-3 w-3" />
      {isDefault
        ? t("primaryVisit.filledBySystem")
        : t("primaryVisit.fromProtocol")}
    </span>
  );
}
